import { supabase } from "@/shared/integrations/supabase/client";

/**
 * Get the percentage of assets for a property that are less than 10 years old.
 * Age comes from the estimated_age_years column. Assets without an age are
 * excluded from the calculation.
 * @param propertyId - The property id to filter assets by
 * @returns Percentage 0–100, or 0 if there are no assets with an age
 */
export async function getAssetsUnder10YearsPercentage(
  propertyId: string
): Promise<number> {
  const { data, error } = await supabase
    .from("property_assets")
    .select("estimated_age_years")
    .eq("property_id", propertyId);

  if (error) throw error;

  const assets = data ?? [];

  const withAge = assets.filter((a) => a.estimated_age_years != null);

  if (withAge.length === 0) return 0;

  const under10 = withAge.filter((a) => (a.estimated_age_years as number) < 10);

  return Math.round((under10.length / withAge.length) * 10000) / 100;
}
